export default __webpack_public_path__ + "media/zurb/img/home/come-in-three-b616ce808958104652747637040e5c09.png";